export const getCurrentAccount = ({ accounts } = {}, accountId) => {
  return accounts.find(account => account.id === accountId);
};

export const getUserRole = ({ accounts } = {}, accountId) => {
  const currentAccount = getCurrentAccount({ accounts }, accountId) || {};
  return currentAccount.role || null;
};

export const routeIsAccessibleFor = (route, role, roleWiseRoutes) => {
  return roleWiseRoutes[role].includes(route);
};

export function hasInboxAgainstBillingPlan(currentAccount) {
  const features = currentAccount.features;
  const inboxes = currentAccount.inboxes;

  const INBOX_TYPES = {
    channel_website: 'Channel::WebWidget',
    channel_facebook: 'Channel::FacebookPage',
    channel_api: 'Channel::Api',
    channel_email: 'Channel::Email',
  };

  const WHITELISTED_INBOXES = [
    'Channel::Sms',
    'Channel::TwitterProfile',
    'Channel::TwilioSms',
    'Channel::Whatsapp',
    'Channel::Telegram',
    'Channel::Line',
  ];

  const allowedInboxTypes = Object.keys(features)
    .filter(key => key.includes('channel_'))
    .map(key => INBOX_TYPES[key]);

  return inboxes.some(inbox => {
    let isWhitelistCheck = WHITELISTED_INBOXES.includes(inbox.channel_type);
    if (isWhitelistCheck) return false;
    console.log(inbox.channel_type, !allowedInboxTypes.includes(inbox.channel_type), isWhitelistCheck);
    return !allowedInboxTypes.includes(inbox.channel_type);
  });
}

const validateActiveAccountRoutes = (
  to,
  user,
  roleWiseRoutes,
  currentAccount
) => {
  const accountDashboardURL = `accounts/${to.params.accountId}/dashboard`;
  const exceedLimitUrl = `accounts/${to.params.accountId}/exceed-license-limit`;
  const unaccessibleInboxes = hasInboxAgainstBillingPlan(currentAccount);

  console.log(currentAccount.subscribed_quantity < currentAccount.count_agents ,
    currentAccount.subscribed_quantity < currentAccount.inboxes.length ,
    unaccessibleInboxes)


  let isExceededLimit = false;

  if (!to.path.includes('settings') && to.name !== 'license_limit') {
    if (
      currentAccount.subscribed_quantity < currentAccount.count_agents ||
      currentAccount.subscribed_quantity < currentAccount.inboxes.length ||
      unaccessibleInboxes
    ) {
      isExceededLimit = true;
      console.log('License limit exceeded', unaccessibleInboxes);
    }
  }

  if (user.type === 'SuperAdmin') {
    console.log('User is SuperAdmin, ignoring redirections');
    return null;
  }

  if (isExceededLimit) {
    console.log('Redirecting to exceed limit URL');
    return exceedLimitUrl;
  }

  if (to.name === 'account_suspended') {
    console.log('Redirecting to dashboard due to suspension');
    return accountDashboardURL;
  }

  const userRole = getUserRole(user, Number(to.params.accountId));
  const isAccessible = routeIsAccessibleFor(to.name, userRole, roleWiseRoutes);

  if (!isAccessible) {
    console.log('Route not accessible for the user role, redirecting to dashboard');
    return accountDashboardURL;
  }

  return null;
};

export const validateLoggedInRoutes = (to, user, roleWiseRoutes) => {
  const currentAccount = getCurrentAccount(user, Number(to.params.accountId));

  if (!currentAccount) {
    console.log('No current account found, redirecting to login');
    return `app/login`;
  }

  const isCurrentAccountActive = currentAccount.status === 'active';

  if (isCurrentAccountActive) {
    return validateActiveAccountRoutes(
      to,
      user,
      roleWiseRoutes,
      currentAccount
    );
  }

  if (to.name !== 'account_suspended') {
    console.log('Current account is suspended, redirecting to suspended page');
    return `accounts/${to.params.accountId}/suspended`;
  }

  return null;
};
